<template>
    <div class="login-body">
        <div class="login-image">
            <img :src="'layout/images/pages/login-on' + color + '.png'" alt="GA Moosehead" />
        </div>
        <div class="login-panel p-fluid grid">
            <div class="flex-column col-4">
                <div class="flex align-items-center logo-container">
                    <img :src="'layout/images/logo-' + color + '.png'" class="login-logo" />
                    <img :src="'layout/images/appname-' + color + '.png'" class="login-appname" />
                </div>
                <form @submit="this.resetPassword">
                    <h4 class="pb-3">Reset Password</h4>
                    <div
                        class="mb-3 border bg-warning border-warning rounded"
                        style="--bs-bg-opacity: 0.2"
                        v-if="!!this.message"
                    >
                        {{ this.message }}
                    </div>
                    <div>
                        <div class="grid mb-3 mr-3">
                            <label class="form-label col-4" for="email">Email:</label>
                            <input
                                class="form-control col-8"
                                type="email"
                                name="email"
                                id="email"
                                v-model="this.email"
                                placeholder="name@example.com"
                                required
                            />
                        </div>
                        <div class="d-flex justify-content-center align-items-center mb-3">
                            <Button class="btn btn-primary" type="submit" label="Reset Password" />
                        </div>
                    </div>
                </form>
                <div class="ms-3 mt-3">
                    <span class="text-end"
                        >Know your login information? <router-link to="/login">Log In</router-link></span
                    >
                </div>
                <div class="ms-3 mt-3">
                    <span class="text-end">Not registered yet? <router-link to="/sign-up">Sign Up</router-link></span>
                </div>
            </div>
        </div>
    </div>
    <div class="login-footer flex align-items-center">
        <AppFooter :colorScheme="color" />
    </div>
</template>

<script>
import AppFooter from '@/AppFooter.vue';

export default {
    name: 'ResetPassword',
    components: { AppFooter },
    data() {
        return {
            email: this.$route.query.email || '',
            message: '',
            color: this.$appState.defaultColorScheme,
        };
    },
    methods: {
        async resetPassword(event) {
            event.preventDefault();

            const formData = {
                email: this.email,
            };

            try {
                await this.$store.dispatch('resetPassword', formData);
            } catch (error) {
                this.message = error.message;
            }
        },
    },
};
</script>
